// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1USTJ","footer":"styles_footer__2bRzC"};